module.exports = __webpack_public_path__ + "static/ashton-kutcher-b1a51cedd738a74647787e1cbaf5103d.jpg";